import { NgModule } from "@angular/core";
import { LoyaltySiteManagementComponent } from "./loyalty-site-management.component";
import { LoyaltySiteManagementTableComponent } from "./loyalty-site-management-table.component";
import { AdminCommonModule } from "../admin-common.module";
import {CollapsibleModule} from 'angular2-collapsible';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MapLocation } from "../map-location/map-location.component";
import { AgmCoreModule } from "@agm/core";


@NgModule({
    declarations: [
        LoyaltySiteManagementComponent,
        LoyaltySiteManagementTableComponent,
        MapLocation
    ],
    imports: [
        AdminCommonModule,
        CollapsibleModule,
        BrowserAnimationsModule,
       AgmCoreModule
    ]
})
export class LoyaltySiteModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/loyalty-site/loyalty-site.module.ts